module.exports = __webpack_public_path__ + "assets/images/seatingarrangement-04.181734871ce837e51f326f0b108728f9.svg";